module.exports = "    <app-feed-card *ngFor=\"let feed of feeds\" [feed]=\"feed\" ></app-feed-card>\n    <app-spinner *ngIf=\"!feeds.length\"></app-spinner>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/news/news.component.html
// module id = ./src/app/components/news/news.component.html
// module chunks = main